import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalCityAll: [],
  generalCity: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalCitySlice = createSlice({
  name: "generalCity",
  initialState,
  reducers: {
    setGeneralCityAll: (state, action) => {
      state.generalCityAll = action.payload;
    },
    setGeneralCity: (state, action) => {
      state.generalCity = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralCityAll,
  setGeneralCity,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalCitySlice.actions;

export default generalCitySlice.reducer;
